<template>
  <div class="widgets-group" v-if="shifts && shifts.length && selected_period">
    <div class="widget-group-content">
      <div class="widget" :key="i" v-for="(shift, i) in shifts">
        <template v-if="shift && shift.id">
          <div 
            class="widget-title"
            :class="{'_gold': ratings[shift.id].index == 1}"
          >
            {{ shift.name }}
          </div>
          <div class="widget-content">
            <div
              class="widget-item current"
              v-if="settings.value.show_goal"
            >
              Goal :
              <span class="value total">
                {{ shift[useByPaymentCapacity(selected_period)].goal | numFormat(currency) }}
              </span>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>

            <div
              class="widget-item current"
              v-if="settings.value.show_goal"
            >
              Current Total :
              <span class="value total">
                <template v-if="target_type === 'Amount'">
                  {{ shift[useByPaymentCapacity(selected_period)][useNetAmount()] | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ shift[useByPaymentCapacity(selected_period)][useNetCount] | numFormat() }}
                </template>
              </span>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>

            <div 
              class="widget-item" 
              v-if="settings.value.show_needed_per_day && selected_period === 'monthly'"
            >
              <p class="per-day">
                Needed Per Week :
                <span class="value needed">
                  {{ shift[useByPaymentCapacity('weekly')].goal | numFormat(currency) }}
                </span>
                <span class="word-sales" v-if="!currency">Sales</span>
              </p>
            </div>

            <div 
              class="widget-item" 
              v-if="settings.value.show_needed_per_day && selected_period !== 'daily'"
            >
              <p class="per-day">
                Needed Per Day :
                <span class="value needed">
                  {{ shift[useByPaymentCapacity('daily')].goal | numFormat(currency) }}
                </span>
                <span class="word-sales" v-if="!currency">Sales</span>
              </p>
            </div>

            <div
              class="widget-item monthly"
              v-if="settings.value.show_needed_per_hour"
            >
              Needed Per Hour :
              <span class="value goal">
                {{ neededPerHour(shift) | numFormat(currency) }}
              </span>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>

            <div 
              class="widget-item working-days" 
              v-if="settings.value.show_working_days && shift[useByPaymentCapacity(selected_period)]"
            >
              Days : Working -
              <span class="value days">
                {{ shift[useByPaymentCapacity(selected_period)].days.working | dayFormat }}
              </span>
              | Left - 
              <span class="value days">
                {{ shift[useByPaymentCapacity(selected_period)].days.remaining }}
              </span>
            </div>

          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { get, orderBy } from "lodash";
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  mixins: [widgetHelper],
  computed: {
    selected_period() {
      return this.settings.value.selected_period;
    },
    shifts() {
      const selected_shifts = this.settings.value?.selected_shifts;
      if (!selected_shifts?.length) { return []; }
      
      let shifts = [];

      for (const selected_shift of selected_shifts) {
        shifts.push(this.getPerShift(selected_shift))
      }

      if (!shifts.length) { shifts = this.streams.streams.statistic.shifts; }

      return orderBy(
        shifts,
        [ (item) => get(item, [[this.useByPaymentCapacity(this.selected_period)], this.useNetAmount()], 0) ], 
        ["desc"] 
      );
    },
    ratings() {
      const places = {};
      this.shifts.forEach((item, i) =>
        (places[item.id] = {
          amount: get(
            item,
            [[this.useByPaymentCapacity(this.selected_period)], this.useNetAmount()],
            0
          ),
          index: i + 1,
        }
      ));
      return places;
    },
    bestAmountItemId() {
      return get(this.shifts, [0, "id"]);
    },
    ...mapGetters(["streams"]),
  },
  data() {
    return {};
  },
  methods: {
    neededPerHour(shift) {
      if (!shift[this.useByPaymentCapacity(this.selected_period)]) { return 0; }
      return shift[this.useByPaymentCapacity('daily')].goal / 8;
    },
  },
};
</script>